import { createFileRoute } from '@tanstack/react-router'
import { AdminClipsPage } from '#pages/admin/AdminClipsPage'

export const Route = createFileRoute('/_admin/admin/clips')({
  component: AdminClipsPage,
})
